import React,{useRef, useState, forwardRef, useImperativeHandle} from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Button, Spinner } from 'react-bootstrap';
import { updateEmailTemplateSetting } from '../../api/axios.js';
import { useGetSignedUrlAndUploadFile } from '../../apiHooks/useAwsService.js';
import { showToast } from '../../Utills/toast.js';

const ApiKey = process.env.REACT_APP_TINYMCE_API_KEY;
const EmailTemplateEditor = forwardRef(({ onSave, row }, ref) => {

console.log("row ==> 56955", row);
    const editorRef = useRef(null);
    const [editorLoading, setEditorLoading] = useState(true);

    const getSignedUrl = useGetSignedUrlAndUploadFile();


    useImperativeHandle(ref, () => ({
      saveTemplate: handleSaveEditor,
    }));

    const handleSaveEditor = async () => {
      console.log("handleSaveEditor");
      if (!editorRef.current) return;
      const content = editorRef.current.getContent();
      const formData = {
        content,
        id: row.id
      };
      try {
        const response = await updateEmailTemplateSetting(row.id, formData);
        showToast({
          type: 'success',
          message: response?.data?.message || "Template updated successfully!",
        });
        if (onSave) onSave(); 
        // onBack && onBack(); 
      } catch (err) {
        
        showToast({
          type: 'error',
          message: err?.response?.data?.message || "Error saving template.",
        });
      } finally {
        console.log("finally");
      }
    };

const variables = [
    // User Information
    {
        name: "First Name",
        value: "{%user_fname%}"
    },
    {
        name: "Last Name",
        value: "{%user_lname%}"
    },
    {
        name: "Email",
        value: "{%email%}"
    },
    {
        name: "Phone Number",
        value: "{%phone_number%}"
    },
    {
        name: "Membership Number",
        value: "{%membership_number%}"
    },
    {
        name: "Membership Name",
        value: "{%membership_name%}"
    },
    {
        name: "Membership Start Date",
        value: "{%membership_start_date%}"
    },
    {
        name: "Membership End Date",
        value: "{%membership_end_date%}"
    },
    {
        name: "Access Code",
        value: "{%access_code%}"
    },
    {
       name: 'End Date',
       value: '{%end_date%}'
    },
    {
      name: "Start Date",
      value: "{%start_date%}"
    },

    // Address Information
    {
        name: "Address Line 1",
        value: "{%address1%}"
    },
    {
        name: "Address Line 2",
        value: "{%address2%}"
    },
    {
        name: "City",
        value: "{%city%}"
    },
    {
      name: "Form URL",
      value: "{%form_url%}"
    },
    {
      name: "Account Holder First Name",
      value: "{%account_holder_fname%}"
    },
    {
        name: "State",
        value: "{%state%}"
    },
    {
        name: "Zipcode",
        value: "{%zipcode%}"
    },
    // URLs and Links
    {
        name: "Base URL",
        value: "{%base_url%}"
    },
    {
        name: "Live Chat URL",
        value: "{%live_chat_url%}"
    },
    {
        name: "Activation URL",
        value: "{%activation_url%}"
    },
    {
        name: "Set Password URL",
        value: "{%set_password_url%}"
    },
    {
      name: "Reset Password URL",
      value: "{%reset_password_url%}"
  },
    {
        name: "Password Recovery URL",
        value: "{%password_recovery_url%}"
    },
    // Images
    {
        name: "Logo",
        value: "{%logo%}"
    },
    {
        name: "Set Password Image",
        value: "{%set_password_image%}"
    },
    {
        name: "Password Recovery Image",
        value: "{%password_recovery_image%}"
    },
    // Membership Details
    {
        name: "Number of Memberships",
        value: "{%number_of_memberships%}"
    },
    {
        name: "Number of Members",
        value: "{%number_of_members%}"
    },
    {
        name: "Member Cards",
        value: "{%member_cards%}"
    },
    {
        name: "Members",
        value: "{%members%}"
    },
    // Status Information
    {
        name: "Status",
        value: "{%status%}"
    },
    {
        name: "Error Message",
        value: "{%error_message%}"
    },
    // File Processing Information
    {
        name: "File Name",
        value: "{%file_name%}"
    },
    {
        name: "Total Members Processed",
        value: "{%total_members_processed%}"
    },
    {
        name: "Total Members Failed",
        value: "{%total_members_failed%}"
    },
    {
        name: "Total Members Success",
        value: "{%total_members_success%}"
    },
    {
        name: "Total Members Duplicate",
        value: "{%total_members_duplicate%}"
    },
    // Other
    {
        name: "Language",
        value: "{%language%}"
    },
    {
        name: "Partner Email",
        value: "{%partner_email%}"
    },
    {
        name: "Message",
        value: "{%message%}"
    },
    {
        name: "Shipping First Name",
        value: "{%shipping_fname%}"
    },
    {
        name: "Shipping Last Name",
        value: "{%shipping_lname%}"
    },
    {
        name: "Shipping Address Line 1",
        value: "{%shipping_address1%}"
    },
    {
        name: "Shipping Address Line 2",
        value: "{%shipping_address2%}"
    },
    {
        name: "Shipping City",
        value: "{%shipping_city%}"
    },
    {
        name: "Shipping State",
        value: "{%shipping_state%}"
    },
    {
        name: "Shipping Zip Code",
        value: "{%shipping_zipcode%}"
    },
    {
        name: "Shipping Phone Number",
        value: "{%shipping_phone_number%}"
    },
    {
        name: "Email Verification Link",
        value: "{%email_verification_link%}"
    },
]

const variableNames = variables.map((item) => item.name.replace(/\s+/g, ""))

const initProperties = {
    height: 750,
    showHeader: false,
    visual: false,
    initialValue: "",
    relative_urls: false,
    remove_script_host: true,
    convert_urls: false,
    plugins: "image code table lists link advlist",
    menubar: "file edit insert view format table tools variables",
    menu: {
      variables: {
        title: "Variables",
        items: variableNames.join(" "),
      },
    },
    image_title: true,
    file_picker_types: "image",
    toolbar_items_size: "small",
    toolbar:
      "custombutton | undo redo | bullist numlist outdent indent advlist | link image | code | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol ",
    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    images_upload_handler:  (blobInfo, progress) => {
     return new Promise(async (resolve, reject) => {

      const file = new File([blobInfo.blob()], blobInfo.filename(), {
        type: blobInfo.blob().type,
      })
      const body = {
        filename: blobInfo.filename(),
        contentType: blobInfo.blob().type,
        partnerId: row?.partner_id,
        file: file
      }
      const response = await getSignedUrl.mutate(body) 
      if(response?.imageUrl){
        resolve(response?.imageUrl)
      }else{
        reject("Error uploading file")
      }
    })},
    setup(editor) {
      editor.on("keydown", (event) => {
        if (event.keyCode == 9) {
          editor.execCommand("mceInsertContent", false, "&emsp;&emsp;")
          event.preventDefault()
          return false
        }
      })

      variables.map((item) => {
        editor.ui.registry.addMenuItem(item.name.replace(/\s+/g, ""), {
          text: item.name,
          onAction() {
            editor.insertContent(`<span>${item?.value}</span>`)
          },
        })
      })

      editor.ui.registry.addButton("custombutton", {
        icon: "plus",
        onAction(_) {
          // Open TinyMCE's link dialog
          editor.windowManager.open({
            title: "Insert Button",
            body: {
              type: "panel",
              items: [
                {
                  type: "input",
                  name: "text",
                  label: "Link Text",
                },
                {
                  type: "input",
                  name: "url",
                  label: "URL",
                },
                {
                  type: "input",
                  name: "title",
                  label: "Title",
                },
                {
                  type: "selectbox",
                  name: "target",
                  label: "Open link in",
                  items: [
                    { value: "", text: "Current window" },
                    { value: "_blank", text: "New window" },
                  ],
                },
              ],
            },
            buttons: [
              {
                type: "cancel",
                text: "Cancel",
              },
              {
                type: "submit",
                text: "Insert",
                primary: true,
              },
            ],
            onSubmit(api) {
              const data = api.getData()
              const attributes = {
                href: data.url,
                title: data.title,
                target: data.target,
                style:
                  "display: inline-block; box-sizing: border-box; cursor: pointer; text-decoration: none; margin: 0px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: normal; background-color: rgb(46, 106, 254); color: rgb(255, 255, 255); border-radius: 8px; border: 1px solid rgb(46, 106, 254); padding: 10px;",
              }
              editor.insertContent(editor.dom.createHTML("a", attributes, data.text))
              api.close()
            },
          })
        },
      })
    },
  }
  return (
    <div>
        {editorLoading && (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )}
        <Editor
            apiKey={ApiKey}
            onInit={(_evt, editor) => {
                editorRef.current = editor;
                setEditorLoading(false);
            }}
            initialValue={row?.content}
            init={initProperties}
        />
        <div>
        {/* <div className={"d-flex items-center justify-content-end space-x-4"}>
            <Button className='w-auto mx-0 mt-3' color={"primary"} size={"md"} onClick={() => (handleSave())} style={{backgroundColor:'#47b0e2c9',border:'none'}}>
            {loading ? <Spinner size="sm" animation="border" /> : 'Save'}
            </Button>
          </div> */}
        </div>
    </div>
  );
})

export default EmailTemplateEditor;
